// English Language Pack
export default {
  // Common
  common: {
    appName: 'Identity V Unified Event Platform',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    prev: 'Previous',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    more: 'More',
    close: 'Close',
    refresh: 'Refresh',
    copy: 'Copy',
    share: 'Share',
    download: 'Download',
    upload: 'Upload',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    noData: 'No Data',
    required: 'Required',
    optional: 'Optional',
    passwordStrength: 'Strength',
    improvementSuggestions: 'Suggestions',
    passwordStrengthWeak: 'Weak',
    passwordStrengthFair: 'Fair',
    passwordStrengthGood: 'Good',
    passwordStrengthStrong: 'Strong',
  },

  // Navigation
  nav: {
    home: 'Home',
    events: 'Events',
    teams: 'Teams',
    articles: 'Posts',
    community: 'Community',
    participants: 'Participants',
    organizer: 'Event Organizer',
    messages: 'Messages',
    notifications: 'Notifications',
    profile: 'Profile',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    search: 'Search',
    docs: 'Documentation',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeTapeFuturism: 'Tape Futurism',
    language: 'Language',
  },

  // Menu Items
  menu: {
    eventBoard: 'Event Board',
    createTeam: 'Create Team',
    editTeam: 'Edit My Team',
    dataAnalysis: 'Data Analysis',
    personalProfile: 'Personal Profile',
    globalSearch: 'Search',
    userDocs: 'Documentation',
    articleList: 'Post List',
    publishArticle: 'Publish Post',
    createEvent: 'Create Event',
    myEvents: 'My Events',
  },

  // Home Page
  home: {
    hero: {
      title: 'Identity V Unified Event Management Platform',
      subtitle: 'Integrated platform for event creation, registration review, and schedule management for all organizers.',
      subtitle2: 'Reduce operational costs, enhance participation experience, and make every match more exciting.',
      createEvent: 'Create Event',
      joinEvent: 'Join Event',
      browseEvents: 'Browse Events',
      free: 'Free to Use',
      oneClickRegistration: 'One-Click Registration',
      efficientManagement: 'Efficient Management',
    },
    features: {
      title: 'Key Capabilities Built for Organizers',
      subtitle: 'Covering the full event lifecycle, reducing operational costs, and enhancing participation experience',
      createEvent: {
        title: 'Create & Configure Events',
        description: 'Support registration time, match time, team limits, event description and other core configurations for quick event publishing.',
      },
      registration: {
        title: 'Registration & Review',
        description: 'Teams register online, administrators review and manage status, ensuring fair and transparent qualification.',
      },
      schedule: {
        title: 'Schedule & Communication',
        description: 'Manage schedules, team information and notifications to improve organization efficiency and participation experience.',
      },
    },
    partners: {
      title: 'Partners',
      subtitle: 'Building a more open and efficient event ecosystem together',
      expand: 'Show More',
      collapse: 'Show Less',
    },
    cta: {
      title: 'Get Started Now',
      subtitle: 'Join us and make event organization easier',
      createNow: 'Create Event Now',
      viewDocs: 'View Documentation',
    },
  },

  // Event Related
  event: {
    title: 'Event',
    list: 'Event List',
    detail: 'Event Details',
    create: 'Create Event',
    edit: 'Edit Event',
    manage: 'Manage Event',
    name: 'Event Name',
    description: 'Event Description',
    status: 'Event Status',
    startTime: 'Start Time',
    endTime: 'End Time',
    regStartTime: 'Registration Start',
    regEndTime: 'Registration End',
    maxTeams: 'Max Teams',
    currentTeams: 'Current Teams',
    organizer: 'Organizer',
    format: 'Format',
    prize: 'Prize',
    rules: 'Rules',
    contact: 'Contact',
    register: 'Register',
    registered: 'Registered',
    registrationClosed: 'Registration Closed',
    registrationNotStarted: 'Registration Not Started',
    bracket: 'Bracket',
    schedule: 'Schedule',
    results: 'Results',
    participants: 'Participants',
    statusLabels: {
      draft: 'Draft',
      published: 'Published',
      registration: 'Registration',
      ongoing: 'Ongoing',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
  },

  // Team Related
  team: {
    title: 'Team',
    list: 'Team List',
    detail: 'Team Details',
    create: 'Create Team',
    edit: 'Edit Team',
    name: 'Team Name',
    tag: 'Team Tag',
    description: 'Team Description',
    logo: 'Team Logo',
    captain: 'Captain',
    members: 'Members',
    memberCount: 'Member Count',
    joinTeam: 'Join Team',
    leaveTeam: 'Leave Team',
    invitePlayer: 'Invite Player',
    kickPlayer: 'Remove Player',
    transferCaptain: 'Transfer Captain',
    disbandTeam: 'Disband Team',
    apply: 'Apply to Join',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    myTeam: 'My Team',
    noTeam: 'No Team',
  },

  // User Related
  user: {
    profile: 'Profile',
    avatar: 'Avatar',
    nickname: 'Nickname',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    changePassword: 'Change Password',
    bio: 'Bio',
    gameId: 'Game ID',
    rank: 'Rank',
    role: 'Role Preference',
    stats: 'Statistics',
    achievements: 'Achievements',
    history: 'History',
    settings: 'Settings',
  },

  // Authentication Related
  auth: {
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    goLogin: 'Login',
    goRegister: 'Register',
    loginSuccess: 'Login Successful',
    logoutSuccess: 'Logged Out',
    registerSuccess: 'Registration Successful',
    welcomeBack: 'Welcome Back',
    verifyEmail: 'Verify Email',
    sendCode: 'Send Code',
    verifyCode: 'Verification Code',
    thirdPartyLogin: 'Sign in with third-party',
    emailPlaceholder: 'Enter your email',
    passwordPlaceholder: 'Enter your password',
    passwordHint: 'At least 8 characters, including letters and numbers; special characters recommended',
    confirmPasswordPlaceholder: 'Enter your password again',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter your full name',
    loginFailed: 'Login failed',
    registerFailed: 'Registration failed',
    emailFormatError: 'Invalid email format',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordMustContainLetterAndNumber: 'Must contain letters and numbers',
    agreeToTerms: 'I have read and agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    mustAgreeToTerms: 'Please agree to the Terms of Service and Privacy Policy',
    loginTitle: 'Login',
    registerTitle: 'Register',
    passwordSuggestLength: 'Increase length to 12+ characters',
    passwordSuggestUppercase: 'Add uppercase letters',
    passwordSuggestLowercase: 'Add lowercase letters',
    passwordSuggestDigit: 'Add numbers',
    passwordSuggestSymbol: 'Add special characters (!@#...)',
  },

  // Article/Post Related
  article: {
    title: 'Post',
    list: 'Post List',
    detail: 'Post Details',
    create: 'Create Post',
    edit: 'Edit Post',
    articleTitle: 'Title',
    content: 'Content',
    category: 'Category',
    tags: 'Tags',
    author: 'Author',
    publishTime: 'Published',
    views: 'Views',
    likes: 'Likes',
    comments: 'Comments',
    share: 'Share',
    collect: 'Collect',
    report: 'Report',
    delete: 'Delete',
  },

  // Message Related
  message: {
    title: 'Messages',
    inbox: 'Inbox',
    sent: 'Sent',
    unread: 'Unread',
    read: 'Read',
    markAsRead: 'Mark as Read',
    markAllRead: 'Mark All Read',
    delete: 'Delete',
    noMessages: 'No Messages',
    newMessage: 'New Message',
    sendMessage: 'Send Message',
    reply: 'Reply',
    conversation: 'Conversation',
  },

  // Notification Related
  notification: {
    title: 'Notifications',
    all: 'All Notifications',
    unread: 'Unread',
    system: 'System',
    event: 'Event',
    team: 'Team',
    markAsRead: 'Mark as Read',
    markAllRead: 'Mark All Read',
    clear: 'Clear All',
    noNotifications: 'No Notifications',
  },

  // Time Related
  time: {
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} hour(s) ago',
    daysAgo: '{n} day(s) ago',
    weeksAgo: '{n} week(s) ago',
    monthsAgo: '{n} month(s) ago',
    yearsAgo: '{n} year(s) ago',
  },

  // Form Validation
  validation: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    emailRequired: 'Please enter your email',
    passwordRequired: 'Please enter your password',
    minLength: 'Minimum {n} characters required',
    maxLength: 'Maximum {n} characters allowed',
    passwordMatch: 'Passwords do not match',
    invalidFormat: 'Invalid format',
  },

  // Error Messages
  errors: {
    networkError: 'Network error, please try again later',
    serverError: 'Server error, please try again later',
    unauthorized: 'Please login first',
    forbidden: 'You do not have permission for this action',
    notFound: 'Requested resource not found',
    unknown: 'An unknown error occurred',
    timeout: 'Request timeout, please try again later',
  },

  // Footer
  footer: {
    copyright: '© {year} Identity V Unified Event Platform',
    allRightsReserved: 'All Rights Reserved',
    contact: 'Contact Us',
    about: 'About Us',
    feedback: 'Feedback',
  },

  // 404 Page
  notFound: {
    title: 'Page Not Found (404)',
    subtitle: 'The link may be incorrect, content moved, or insufficient permissions.',
    goHome: 'Go Home',
    goEvents: 'Go to Events',
    goArticles: 'Go to Articles',
    trySearch: 'Try Site Search',
    searchPlaceholder: 'e.g., ASG, Fall Season, Team Name',
    searchButton: 'Search',
    goBack: 'Go Back',
    possibleReasons: 'Possible Reasons',
    reason1: 'Link is incorrect or expired',
    reason2: 'Content has been deleted or moved',
    reason3: 'Login required to access',
    reason4: 'Insufficient permissions',
  },

  // Event Board Page
  eventBoard: {
    title: 'Event Board',
    subtitle: 'Browse events currently accepting registration and upcoming events',
    activeRegistration: 'Registration Open',
    upcomingEvents: 'Upcoming',
    activeRegistrationTab: 'Registration Open',
    upcomingTab: 'Upcoming',
    noActiveEvents: 'No events currently accepting registration',
    noUpcomingEvents: 'No upcoming events',
    registerNow: 'Register Now',
    viewDetails: 'View Details',
    loadingEvents: 'Loading events...',
    registrationPeriod: 'Registration Period',
    eventPeriod: 'Event Period',
    teamsCount: '{current}/{max} Teams',
    registerSuccess: 'Registration successful',
    registerFailed: 'Registration failed',
  },

  // Team Create Page
  teamCreate: {
    title: 'Create Team',
    subtitle: 'Fill in team information and invite members',
    teamInfo: 'Team Information',
    teamName: 'Team Name',
    teamPassword: 'Team Password',
    teamPasswordHint: 'Used for member verification when joining',
    qqNumber: 'QQ Number',
    qqNumberRequired: 'Please enter QQ number',
    teamDescription: 'Team Description',
    teamLogo: 'Team Logo',
    uploadLogo: 'Upload Logo',
    generateAiLogo: 'Generate with AI',
    playerList: 'Player List',
    addPlayer: 'Add Player',
    removePlayer: 'Remove',
    hidePlayers: 'Hide Player Info',
    hidePlayersHint: 'Other users cannot view player details when hidden',
    createSuccess: 'Team created successfully, redirecting to edit page',
    createFailed: 'Failed to create team',
    descriptionTooLong: 'Team description must be less than 1000 characters',
    logoRequired: 'Please upload team logo or generate with AI',
    generating: 'Generating...',
    polishing: 'Polishing...',
  },

  // Player Info Form
  player: {
    name: 'Player Name',
    gameId: 'Game ID',
    gameRank: 'Rank',
    description: 'Description',
    playerType: 'Role Type',
    survivor: 'Survivor',
    hunter: 'Hunter',
    both: 'Both',
  },

  // Common Page Components
  page: {
    loadMore: 'Load More',
    noMoreData: 'No more data',
    loading: 'Loading...',
    retry: 'Retry',
    page: 'Page {n}',
    totalPages: '{n} pages total',
    prevPage: 'Previous',
    nextPage: 'Next',
    goToPage: 'Go to',
  },

  // Privacy Policy Page
  privacy: {
    title: 'Privacy Policy',
    intro: 'This platform values your privacy and data security. This privacy policy explains how we collect, use, store and protect your personal information, and your rights in personal information processing.',
    section1: 'Information Collected',
    section1Content: 'Personal information we may collect includes: email, nickname or name, team information, event participation records, articles and interaction data you publish on the platform, and log information required for security.',
    section2: 'Use of Information',
    section2Content: 'We use this information to provide and improve platform services, including account authentication and security, event management and notifications, community interaction, content recommendations and statistical analysis.',
    section3: 'Cookies and Local Storage',
    section3Content: 'The platform may use Cookies or local storage to save login status and preference settings. You can manage or clear them through browser settings.',
    section4: 'Information Sharing and Disclosure',
    section4Content: 'We will not sell or disclose your personal information to unauthorized third parties unless required by laws and regulations, law enforcement requests, or necessary to protect the legitimate rights and interests of the platform and users.',
    section5: 'Data Security',
    section5Content: 'We adopt reasonable technical and management measures (such as encryption and access control) to protect your data security, but cannot guarantee absolute security. Please keep your account and password safe.',
    section6: 'Data Retention',
    section6Content: 'We will retain personal information for the shortest period required to achieve the purpose, and archive or delete data according to laws, regulations and business needs.',
    section7: 'Your Rights',
    section7Content: 'You have the right to access, correct and delete personal information, and may withdraw authorization or apply for account cancellation within the scope permitted by law. Some requests may affect service use.',
    section8: 'Protection of Minors',
    section8Content: 'If you are a minor, you should use this platform under the guidance of a guardian. We will not actively collect personal information of minors without guardian consent.',
    section9: 'Policy Updates',
    section9Content: 'The privacy policy may be updated due to business or legal changes. The updated policy will take effect after being published on the platform, and continued use means you have agreed.',
    section10: 'Contact Us',
    section10Content: 'If you have any questions or complaints about the privacy policy or personal information processing, you can contact us through the platform feedback channel.',
  },

  // Terms of Service Page
  terms: {
    title: 'Terms of Service',
    intro: 'Welcome to Identity V Unified Tournament Platform (hereinafter referred to as "this platform"). To protect your legitimate rights and interests, please read and agree to this user agreement carefully before use. This platform provides event organizers, participants and community users with event creation and management, team information maintenance, schedule and score entry, article publishing and interaction services.',
    section1: 'Account Registration and Use',
    section1Content: 'You should register an account with a real and legal email address and properly keep login credentials. You are responsible for content and operations created through this platform.',
    section2: 'Platform Usage Standards',
    section2Content: 'You must not use this platform to engage in any illegal, irregular or harmful activities to others\' legitimate rights and interests, including but not limited to: publishing inappropriate content, malicious attacks, destroying platform or others\' data, unauthorized data scraping and copying.',
    section3: 'Content and Intellectual Property',
    section3Content: 'Text, images, videos and other content you publish on this platform should ensure you have legal usage rights or have obtained necessary authorization. Unauthorized reprinting or commercial use is prohibited. This platform enjoys corresponding intellectual property rights over its provided functions, interfaces and code.',
    section4: 'Data and Security',
    section4Content: 'This platform adopts reasonable technical and management measures to ensure data security and service stability, but service interruption or data loss may still occur due to network and force majeure factors. Users are responsible for account leakage and losses caused by their own reasons.',
    section5: 'Events and Schedules',
    section5Content: 'Event organizers should ensure the authenticity and compliance of event information, and properly manage schedules, scores and participating team information. Participants should follow event rules and respect referees and other participants.',
    section6: 'Notifications and Emails',
    section6Content: 'This platform may send you service emails related to account security, password reset, event reminders, etc. You can choose to receive and unsubscribe within the scope permitted by law.',
    section7: 'Liability and Disclaimer',
    section7Content: 'For service anomalies caused by third-party services, network environment or force majeure, this platform is not liable for resulting indirect losses. Users are responsible for losses caused by violations of this agreement or laws and regulations.',
    section8: 'Agreement Updates',
    section8Content: 'This platform may update the agreement according to business and legal changes. The updated agreement will take effect once published, and if you continue to use this platform, it is deemed that you have accepted the updated content.',
    section9: 'Applicable Law and Dispute Resolution',
    section9Content: 'This agreement is governed by relevant laws and regulations. Disputes arising from this agreement should be resolved through friendly negotiation; if negotiation fails, submit to the people\'s court with jurisdiction.',
    section10: 'Contact Information',
    section10Content: 'If you have any questions about this agreement or platform use, you can contact us through the platform feedback channel.',
  },

  // Comprehensive Search Page
  search: {
    title: 'Search',
    subtitle: 'Search teams, events and articles by keyword',
    placeholder: 'Search site content (Teams / Events / Articles)',
    searchType: 'Search Type',
    all: 'All',
    teams: 'Teams',
    events: 'Events',
    articles: 'Articles',
    searchButton: 'Search',
    teamsCount: 'Teams: {count}',
    eventsCount: 'Events: {count}',
    articlesCount: 'Articles: {count}',
    teamResults: 'Team Results',
    eventResults: 'Event Results',
    articleResults: 'Article Results',
    noTeamsFound: 'No teams found',
    noEventsFound: 'No events found',
    noArticlesFound: 'No articles found',
    tryDifferentKeyword: 'Try a different keyword or check spelling',
    membersHidden: 'Members Hidden',
    noDescription: 'No team description',
    expand: 'Expand',
    collapse: 'Collapse',
    viewDetail: 'View Details',
    like: 'Like',
  },

  // Forgot Password Page
  forgotPassword: {
    title: 'Forgot Password',
    emailLabel: 'Email',
    sendResetEmail: 'Send Reset Email',
    backToLogin: 'Back to Login',
    successMsg: 'If the email exists, we have sent a reset email',
    emailRequired: 'Please enter your email',
    emailFormatError: 'Invalid email format',
    operationFailed: 'Operation failed',
  },

  // Reset Password Page
  resetPassword: {
    title: 'Reset Password',
    emailLabel: 'Email',
    tokenLabel: 'Token',
    newPasswordLabel: 'New Password',
    confirmPasswordLabel: 'Confirm New Password',
    submitButton: 'Submit',
    backToLogin: 'Back to Login',
    successMsg: 'Password updated',
    emailRequired: 'Please enter your email',
    emailFormatError: 'Invalid email format',
    tokenRequired: 'Please enter token',
    passwordRequired: 'Please enter new password',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordMustContainLetterAndNumber: 'Must contain letters and numbers',
    confirmPasswordMismatch: 'Passwords do not match',
    operationFailed: 'Operation failed',
  },

  // OAuth New Account Page
  oauthNewAccount: {
    title: 'Complete Account Information',
    fullNameLabel: 'Full Name',
    saveButton: 'Save',
    continueButton: 'Continue',
    loginFailed: 'Login failed',
    loggedIn: 'Logged in',
    loggedInVia: 'Logged in via {provider}',
    profileUpdated: 'Profile updated',
    saveFailed: 'Save failed',
    bindOtherAccounts: 'Bind Other Third-Party Accounts',
    bindGithub: 'Bind GitHub',
    bindMicrosoft: 'Bind Microsoft',
    bindQQ: 'Bind QQ',
  },

  // Documentation Page
  docsUsage: {
    title: 'Documentation',
    subtitle: 'Platform usage guide and getting started',
    backToHome: 'Back to Home',
  },

  // Web Embed Page
  webEmbed: {
    loading: 'Loading...',
  },

  // Login Callback Page
  loginCallback: {
    loggingIn: 'Logging in',
    loginFailed: 'Login failed',
  },
}
